import Axios from '@/utils/Axios';

export interface RequestData {
  /**
   * 学科；账号在该学科下必须已有教材档案
   */
  subject: number;
}

/**
 * 把某个学科标记为账号当前所在的学科（仅 FS 平台使用），不改教材档案里的单元和课
 */
export default async function putProfileCurrentSubject(
  data: RequestData,
  token?: string | null,
) {
  await Axios.put(`/users/profile/current-subject`, data, {
    ...(token !== undefined ? { fsSessionToken: token } : {}),
  });
}
